import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Divider,Stack,TextField,Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useContext,useEffect,useState } from 'react';
import { WebFormContext } from '../../../../context/WebFormContext';
import { SubItemFormFilling } from '../../../../types/new-form-filling/types';
import { Paragraph } from '../../../Notifications/style/SingleNotificationStyle';
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from '../../Structure/AdditionalInfo';

type Props = {
  subitem: SubItemFormFilling,
  lista: { texto: string }[] | null
  setLista: Function,
};

export default function TextFieldList({
  subitem,
  lista,
  setLista,
}: Props) {
  const [texto, setTexto] = useState<string | null>(null);
  const { ForceUpdate } = useContext(WebFormContext);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, lista) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();


  useEffect(() => {
    if (subitem.selecionados) {
      setLista(subitem.selecionados);
    } else if (subitem.padraoLista) {
      setLista(subitem.padraoLista?.map(e => ({ texto: e })));
      subitem.selecionados = subitem?.padraoLista?.map(e => ({ texto: e }));
    }
    if (CheckIcon(subitem, lista) === 'ok') {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (lista?.length) {
      subitem.selecionados = lista;
    }
    if (CheckIcon(subitem, lista) === 'ok') {
      subitem.checked = true;
    } else {
      delete subitem.checked;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lista]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <Stack
        direction={'column'}
        justifyContent="space-between"
        spacing={0.5}
        width={'100%'}
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <TextField
            value={texto ?? ''}
            onKeyPress={(event) => {
              if (typeof texto === 'string' && texto?.length > 0) {
                if (event.key === 'Enter') {
                  setLista([...lista as { texto: string }[] || '', { texto: texto }]);
                  setTexto('');
                }
              }
            }}
            rows={1}
            size='small'
            className={`${subitem.itemid}|${subitem.id}`}
            placeholder='Adicione textos a lista'
            fullWidth
            onChange={(eve) => {
              eve.preventDefault();
              setTexto(eve.target.value);
            }}
          />
          <AddCircleIcon
            fontSize='large'
            sx={{ ':hover': { cursor: 'pointer' }, color: '#4E388C' }}
            onClick={() => {
              if (typeof texto === 'string' && texto?.length > 0) {
                setLista([...lista as { texto: string }[] || '', { texto: texto }]);
                setTexto('');
              }
            }}
          />
        </Stack>
        <Stack
          sx={{ maxHeight: '200px', overflowY: 'auto' }}
          width={'100%'}
          spacing={2}
        >
          {(lista as { texto: string }[])?.length > 0 &&
            <>
              <Paragraph>Lista de textos:</Paragraph>
              {(lista as { texto: string }[])?.map((step, index) => (
                <React.Fragment key={step.texto + index}>
                  <Stack
                    alignItems="center"
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Typography sx={{ fontSize: 14, wordBreak: 'break-word' }} color="text.secondary">
                      {step.texto}
                    </Typography>
                    <Tooltip title="Remover texto">
                      <RemoveCircleOutlineIcon
                        onClick={() => {
                          if ((lista as { texto: string }[])?.length > 1) {
                            setLista(lista?.filter((ele) => ele !== step));
                          } else {
                            setLista(null);
                            delete subitem.selecionados;
                          }
                        }}
                        color='error'
                        sx={{ cursor: 'pointer', ":hover": { color: '#ab003c' } }}
                      />
                    </Tooltip>
                  </Stack>
                  {(lista as { texto: string }[])?.length > 1 && <Divider />}
                </React.Fragment>
              ))}
            </>
          }
        </Stack>
      </Stack>
      {(lista as { texto: string }[])?.length > 0 && <AdditionalInfo subItem={subitem} />}
    </>
  );
}